<template>
  <div v-if="loadComponent">
    <v-form ref="form">
      <v-container>
        <h1>Earnings And Deductions</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="ed.code"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="ed.desc"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-select
              label="Type"
              :loading="typeCodeLoading"
              :items="typeCode"
              item-text="descrp"
              item-value="typeCD"
              :class="classPadding"
              v-model="ed.type"
              clearable
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-radio-group v-model="typeGroup" row :class="classPadding">
              <v-radio label="Earning" value="EARNTYPE"></v-radio>
              <v-radio label="Deduction" value="DEDUTYPE"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="company.showNonVATEcola">
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-radio-group v-model="nonVATEcola" column :class="classPadding">
              <v-radio
                label="Non-Taxable (Include these earnings in the PME report field for Non-Taxable)"
                :value="0"
              ></v-radio>
              <v-radio
                label="E-Cola PME Field (Include these earnings in the PME report field for E-Cola)"
                :value="1"
              ></v-radio>
              <v-radio
                label="Fixed Allowance (Include these earnings in the PME report field for Fixed Allowance)"
                :value="2"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-radio-group v-model="alloType" column :class="classPadding">
              <v-radio
                label="Deminimis (Include these earnings in the Masterlists field for Deminimis)"
                :value="1"
              ></v-radio>
              <v-radio
                label="Salary (Include these earnings in the Masterlists field for Salary)"
                :value="2"
              ></v-radio>
              <v-radio
                label="None (Exclude these earnings in the Masterlists field)"
                :value="0"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-container>
      <list></list>
      <router-view />
    </v-container>
  </div>
</template>
<script>
import List from "./List";
import EventBus from "../../../../events/eventBus";
import { mapState, mapActions } from "vuex";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/earnDeduc";
export default {
  metaInfo: {
    title: "Earnings And Deductions",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List
  },
  data: () => ({
    ed: {},
    classPadding: "my-0 py-0",
    typeCode: [],
    typeCodeLoading: false,
    typeGroup: "EARNTYPE",
    alloType: 0,
    nonVATEcola: 0,
    isSaving: false
  }),
  methods: {
    ...mapActions("company", ["getCompanyInfo"]),
    getTypeCode(group) {
      this.typeCodeLoading = true;

      this.$axios
        .get(`${API_ENDPOINT}/typeCode/${group}`)
        .then(({ data }) => {
          this.typeCode = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.typeCodeLoading = false;
        });
    },
    getTypes(type) {
      EventBus.$emit("SELECTED_TYPEGROUP", type);
    },
    save() {
      this.isSaving = true;
      this.ed.typeGroup = this.typeGroup;
      this.ed.tag = this.alloType;
      this.ed.nonVATEcola = this.nonVATEcola;
      this.$axios
        .post(`${API_ENDPOINT}`, this.ed)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.getTypes(this.type);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    reset() {
      //this.$refs.form.reset();
      this.ed = {};
      this.typeGroup = "EARNTYPE";
      this.alloType = 0;
    }
  },
  created() {
    this.getUserAccessRights("EarnDeducS");
    this.getTypeCode(this.typeGroup);
    this.getTypes(this.type);
    this.getCompanyInfo();
    
  },
  mounted() {
    
  },
  computed: {
    ...mapState("company", {
      company: state => state.company
    }),
    type() {
      let type = "";
      if (this.typeGroup === "EARNTYPE") {
        type = "Earnings";
      } else {
        type = "Deductions";
      }

      return type;
    }
  },
  watch: {
    typeGroup(val) {
      this.getTypeCode(val);

      this.getTypes(this.type);
    }
  }
};
</script>
